import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PersonalDataForm from '@containers/Auth/components/personal-data-form';
import { useDispatch, useSelector } from 'react-redux';
import { AuthenticationDialog } from '@single-platform/components';
import { AuthActions } from '@redux';
import { allLoginStatus, history } from '@config';
import { Logout } from '@utilities';
import { OtpForm } from '@containers/Auth/methods/otp/otpForm';
import { UnauthorizedCompanyModal } from '@components/Signing/UnauthorizedCompanyModal';
import { storageHandler } from '@containers/SSOLoginContainer/storageHandler';

export const MobileID = ({ personalData, setSubmitStatus, setCurrentStep }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [personalId, setPersonalId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [requiresOtp, setRequiresOtp] = useState(false);
  const [isWaitingForConfirmation, setIsWaitingForConfirmation] = useState(false);
  const authState = useSelector((state) => state.AuthReducers);
  const [isUnauthorizedCompany, setIsUnauthorizedCompany] = useState(false);
  const [challengeCompleted, setChallengeCompleted] = useState(false);

  const submit = (data) => {
    setPersonalId(data.customerId);
    setPhoneNumber(data.phone);
    setIsWaitingForConfirmation(true);
  };

  const initiateLogin = async () => {
    const data = {
      personalCode: personalId,
      phoneNumber: phoneNumber,
      email: personalData.email,
      country: personalData.country
    };
    if (data.personalCode) {
      const response = await dispatch(AuthActions.mobileIdInit(data));
      setSubmitStatus({
        isSubmitting: true,
        type: 'mobileId'
      });
      return response.payload;
    }
  };

  const completeLogin = async ({ sessionId, token }) => {
    if (!sessionId) {
      return { state: 'failed' };
    }
    sessionStorage.setItem('loginToken', token);
    sessionStorage.setItem('loginSessionId', sessionId);
    const response = await dispatch(AuthActions.authorizationStatus(token));

    if (response.payload.state === 'ok') {
      setIsWaitingForConfirmation(true);
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    return response.payload;
  };

  const onBackHandle = () => {
    authState.isWaitingForConfirmation = false;
    setIsWaitingForConfirmation(false);
    setSubmitStatus({
      isSubmitting: false,
      type: null
    });
    setCurrentStep('loginMethods');
  };

  const onSuccessHandle = async (data) => {
    if (data.emailOtpRequired) {
      setRequiresOtp(true);
    } else {
      const token = {
        refreshToken: data.refreshToken,
        accessToken: data.token,
        expiresIn: data.expiresIn
      };
      storageHandler.setSessionStorage('token', token);
      storageHandler.setSessionStorage('authType', 'Mobile');
      await authorizedCompanies();

      setChallengeCompleted(true);
    }
  };

  const authorizedCompanies = async () => {
    const result = await dispatch(AuthActions.getAuthorizedCompanies());
    if (result) {
      switch (result.payload.status) {
        case allLoginStatus.noAuthorizeCompany:
          setIsUnauthorizedCompany(true);
          break;
        case allLoginStatus.selectCompany:
          history.push('/registration');
          break;
        default:
          break;
      }
    } else onFailHandle();
  };

  const onFailHandle = async () => {
    sessionStorage.clear();
    setIsUnauthorizedCompany(false);
    await Logout();
    setRequiresOtp(false);
    setIsWaitingForConfirmation(false);
    authState.isWaitingForConfirmation = false;
    setSubmitStatus({
      isSubmitting: false,
      type: null
    });
  };

  const pollingConfiguration = {
    init: initiateLogin,
    complete: completeLogin
  };

  useEffect(() => {
    setPersonalId('');
    if (authState.isWaitingForConfirmation !== undefined) {
      setIsWaitingForConfirmation(authState.isWaitingForConfirmation);
    }
  }, [authState.isWaitingForConfirmation]);

  return (
    <>
      {!requiresOtp ? (
        <AuthenticationDialog
          hideBackLink
          testId="mobile-id"
          isWaitingForConfirmation={!!isWaitingForConfirmation}
          onBackHandle={onBackHandle}
          onSuccessHandle={onSuccessHandle}
          onFailHandle={onFailHandle}
          backLinkLabel={t('back')}
          timerLabel={t('smart_Id_timer_label')}
          infoMessage={t('smart_Id_Info_Message')}
          pollingConfig={pollingConfiguration}
          challengeCompleted={challengeCompleted}
        >
          <PersonalDataForm displayPhoneInput onSubmit={submit} />
        </AuthenticationDialog>
      ) : (
        <OtpForm otpRequest={authorizedCompanies}></OtpForm>
      )}
      {isUnauthorizedCompany && <UnauthorizedCompanyModal onCancel={onFailHandle} />}
    </>
  );
};
